import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { MdOutlineDelete } from "react-icons/md";
import axios from "axios";
import { products_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function ProdDelete({callback, data}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
    
  const call = ()=> {
    callback();
  }


  const Delete = async() =>{
    setLoad(true);
    try{
      const res = await axios.delete(products_uri+`/delete?id=${data.id}`);
      if(res.status === 200) {
        toast.success("Амжилттай устгалаа");
        call(); 
      }
      setLoad(false);
    }catch(err){
        setLoad(false);
      console.log(err);
    }
  }

  return (
    <>
      <MdOutlineDelete onClick={onOpen} className='cursor-pointer' color='red' size={20}/>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex justify-between gap-1 font-Roboto">
                
              </ModalHeader>
              <ModalBody>
                <div className="font-Roboto ">
                    Устгах уу ?  <span className="font-bold">{data.name}</span>
                    <div>
                        Анх үүсгэсэн огноо  <span className="font-bold">{data.created_date}</span>
                    </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                {
                    load ?
                    <Button color="danger" variant="light">
                        <Spinner/>
                    </Button>
                    :
                    <Button color="danger" variant="light" onPress={Delete}>
                    Устгах
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}